// ----------------------------------------------------------------------
// <copyright file="Izenda.AuthorizationValidator.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {


  var React = require('react');
  var m = require('mobx');
  var observer = require('mobx-react').observer;
  const { isNil, omit, assign } = require('lodash/fp');
  function AuthorizationValidator() {
    return function(BaseComponent) {
      var AuthorizableEditor = React.createClass({
        displayName: 'Authorization(' + BaseComponent.displayName + ')',
        propTypes: {
          // Authorization keys
          keys: React.PropTypes.oneOfType([React.PropTypes.object.isRequired, React.PropTypes.array.isRequired]),
          // Hide in integration mode
          integrationHidden: React.PropTypes.bool,
          // Hide when not having sufficient privilege
          authHidden: React.PropTypes.bool,
          // Overriding authorization function
          onAuth: React.PropTypes.func
        },
        contextTypes: {
          authorization: React.PropTypes.oneOfType([React.PropTypes.array, React.PropTypes.object])
        },
        getDefaultProps: function() {
          return {
            authHidden: true,
            integrationHidden: false
          };
        },

        componentWillMount: function() {
          // User has sufficient privilege to see the component
          this.hasPrivilege = this.context.authorization.checkPrivileges(this.props.keys);
          // The component should be hidden as the system is in integration mode.
          this.hideAsIntegration = this.props.integrationHidden && this.context.authorization.isIntegrationMode();
        },

        /**
         * Build properties
         * @returns {Object} rest of properties
         */
        buildProps: function() {
          var rest = omit(['keys', 'authHidden', 'integrationHidden'], this.props);

          if (isNil(this.props.onAuth)) {
            return rest;
          } else {
            return assign(rest, this.props.onAuth());
          }
        },

        render: function() {
          var rest = this.buildProps();

          // Hide the component when
          //    - NOT have privilege and it needs to be hidden by privilege
          //    - OR hide in integration mode
          var shouldHide = (!this.hasPrivilege && this.props.authHidden) || this.hideAsIntegration;

          return shouldHide ? null : <BaseComponent {...rest} />;
        }
      });

      return observer(AuthorizableEditor);
    };
  }

  module.exports = AuthorizationValidator;
})();



// WEBPACK FOOTER //
// ./ui/share/components/hoc/Izenda.AuthorizationValidator.jsx